<template>
  <ResetPasswordSuccess />
</template>

<script>
import ResetPasswordSuccess from '../components/templates/ResetPasswordSuccess'

export default {
  components: {
    ResetPasswordSuccess
  }
}
</script>
